var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-footer",
    {
      staticClass: "govgr-layout-wrapper",
      staticStyle: { height: "initial" },
      attrs: { role: "contentinfo" }
    },
    [
      _c("div", { staticClass: "govgr-full-width-container" }, [
        _vm.showAppInfo
          ? _c(
              "div",
              { staticClass: "gov-text-center-alignment" },
              [
                _c("b", [_vm._v("Release | Frontend: ")]),
                _vm._v(" "),
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      placement: "top",
                      "open-delay": 800,
                      effect: "light",
                      "popper-class": "release-details-tooltip"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "release-tooltip-content",
                        attrs: { slot: "content" },
                        slot: "content"
                      },
                      [
                        _c("div", { staticClass: "tooltip-section" }, [
                          _c("div", [
                            _c("strong", [_vm._v("Release ID:")]),
                            _vm._v(" " + _vm._s(_vm.config.currentRelease.id))
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("strong", [_vm._v("Version:")]),
                            _vm._v(
                              " " + _vm._s(_vm.config.currentRelease.version)
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("strong", [_vm._v("Type:")]),
                            _vm._v(" " + _vm._s(_vm.config.currentRelease.type))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "multi-line-text" }, [
                            _c("strong", [_vm._v("Title:")]),
                            _vm._v(
                              " " + _vm._s(_vm.config.currentRelease.title)
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "tooltip-section" }, [
                          _c("div", [_c("strong", [_vm._v("Build Details:")])]),
                          _vm._v(" "),
                          _c("div", { staticClass: "indent" }, [
                            _c("div", [
                              _vm._v(
                                "Number: " +
                                  _vm._s(_vm.config.currentRelease.build.number)
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                "Author: " +
                                  _vm._s(_vm.config.currentRelease.build.author)
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                "Start Date: " +
                                  _vm._s(
                                    _vm.config.currentRelease.build.startDate
                                  )
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                "Build Date: " +
                                  _vm._s(
                                    _vm.config.currentRelease.build.date ||
                                      "N/A"
                                  )
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "tooltip-section" }, [
                          _c("div", [
                            _c("strong", [
                              _vm._v(
                                "Commits (" +
                                  _vm._s(
                                    _vm.config.currentRelease.build.commits
                                      .length
                                  ) +
                                  "):"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "indent" }, [
                            _c(
                              "ul",
                              { staticClass: "commits-list" },
                              _vm._l(
                                _vm.config.currentRelease.build.commits,
                                function(commit) {
                                  return _c("li", { key: commit.sha }, [
                                    _c("span", { staticClass: "commit-type" }, [
                                      _vm._v(_vm._s(commit.type) + ":")
                                    ]),
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(commit.message) +
                                        "\n                  "
                                    ),
                                    _c("span", { staticClass: "commit-meta" }, [
                                      _vm._v(
                                        "(" + _vm._s(_vm.formatSha(commit.sha))
                                      ),
                                      commit.issues && commit.issues.length > 0
                                        ? _c("span", [
                                            _vm._v(
                                              ", " +
                                                _vm._s(
                                                  _vm.formatIssues(
                                                    commit.issues
                                                  )
                                                )
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(")")
                                    ])
                                  ])
                                }
                              )
                            )
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.config.FRONTEND_RELEASE) + ", ")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("b", [_vm._v("Backend: ")]),
                _vm._v(" "),
                _vm.backendReleaseData
                  ? _c(
                      "el-tooltip",
                      {
                        attrs: {
                          placement: "top",
                          "open-delay": 800,
                          effect: "light",
                          "popper-class": "release-details-tooltip"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "release-tooltip-content",
                            attrs: { slot: "content" },
                            slot: "content"
                          },
                          [
                            _c("div", { staticClass: "tooltip-section" }, [
                              _c("div", [
                                _c("strong", [_vm._v("Version:")]),
                                _vm._v(
                                  " " + _vm._s(_vm.backendReleaseData.version)
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _c("strong", [_vm._v("Date:")]),
                                _vm._v(
                                  " " + _vm._s(_vm.backendReleaseData.date)
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _c("strong", [_vm._v("Issue:")]),
                                _vm._v(
                                  " " + _vm._s(_vm.backendReleaseData.issue)
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "multi-line-text" }, [
                                _c("strong", [_vm._v("Description:")]),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.backendReleaseData.description)
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _vm.backendReleaseData.changes
                              ? _c("div", { staticClass: "tooltip-section" }, [
                                  _c("div", [
                                    _c("strong", [_vm._v("Changes:")])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "indent" },
                                    _vm._l(
                                      _vm.backendReleaseData.changes,
                                      function(changeList, changeType) {
                                        return _c("div", { key: changeType }, [
                                          _c("div", [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatChangeType(
                                                    changeType
                                                  )
                                                ) + ":"
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "ul",
                                            { staticClass: "changes-list" },
                                            _vm._l(changeList, function(
                                              change,
                                              index
                                            ) {
                                              return _c("li", { key: index }, [
                                                _vm._v(_vm._s(change))
                                              ])
                                            })
                                          )
                                        ])
                                      }
                                    )
                                  )
                                ])
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.backendVersion))])
                      ]
                    )
                  : _c("span", [_vm._v(_vm._s(_vm.backendVersion))]),
                _vm._v(" "),
                _c("b", [_vm._v(" URL:")]),
                _vm._v(" " + _vm._s(_vm.config.BASE_URL) + " "),
                _c("b", [_vm._v("User type:")]),
                _vm._v(" " + _vm._s(_vm.config.USER_TYPE) + "\n    ")
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "govgr-footer__meta" }, [
          _c(
            "div",
            {
              staticClass:
                "govgr-footer__meta-item govgr-footer__meta-item--grow"
            },
            [
              _c(
                "div",
                { staticClass: "govgr-footer__content gov-text-valign-center" },
                [
                  _c(
                    "p",
                    { staticClass: "govgr-footer__licence-description" },
                    [
                      _c("span", { on: { click: _vm.toggleAppInfo } }, [
                        _vm._v("© Copyright 2020")
                      ]),
                      _vm._v("\n           - Υλοποίηση από το "),
                      _c(
                        "a",
                        {
                          staticClass: "govgr-link",
                          attrs: {
                            href: "https://www.minedu.gov.gr/",
                            target: "_blank",
                            rel: "noreferrer noopener"
                          }
                        },
                        [
                          _vm._v(
                            " Υπουργείο Παιδείας, Θρησκευμάτων και Αθλητισμού"
                          )
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "govgr-footer__meta-item" }, [
                _c("a", { attrs: { href: "https://e-doatap.doatap.gr" } }, [
                  _c("img", {
                    staticClass: "gov-footer-secondary-logo",
                    attrs: { src: require("../assets/Logo-eDoatap_Color.png") }
                  })
                ])
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "govgr-full-width-container" }, [
        _c("div", { staticClass: "govgr-footer__content" }, [
          _c("div", { staticClass: "gov-text-center-alignment" }, [
            _vm._v("\n        " + _vm._s(_vm.developmentTeam) + "\n      ")
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-95ddf904", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-95ddf904","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Foot.vue
// module id = null
// module chunks = 